"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _ContentEditable = _interopRequireDefault(require("./ContentEditable"));
var _index = _interopRequireWildcard(require("../@i18n/index"));
var _common = require("../@api/common");
var _store = require("../@api/store");
var _excluded = ["avatar", "text", "color", "onClick", "onRightIconClick", "rightIcon"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/// GROUP CHAT based on appcenter groups

var Chip = _react["default"].forwardRef(function (_ref, ref) {
  var avatar = _ref.avatar,
    text = _ref.text,
    color = _ref.color,
    onClick = _ref.onClick,
    onRightIconClick = _ref.onRightIconClick,
    rightIcon = _ref.rightIcon,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, rest, {
    ref: ref,
    className: "chip ".concat(color || '', " ").concat(onClick ? 'clickable' : ''),
    onClick: onClick
  }), !!avatar && /*#__PURE__*/_react["default"].createElement("div", {
    className: "avatar"
  }, avatar), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text"
  }, text), (!!rightIcon || !!onRightIconClick) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "right-icon ".concat(onRightIconClick ? 'clickable' : ''),
    onClick: onRightIconClick
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: rightIcon || 'faTimes'
  })));
});
var _default = Chip;
exports["default"] = _default;